import { defineStore } from 'pinia'

import { StoreId } from '@/store'

import { BasketStep } from '@/types/basket'

type State = {
  step: BasketStep
}

export const useBasketStateStore = defineStore({
  id: StoreId.BASKET_STATE,
  state: (): State => {
    return {
      step: BasketStep.FIRST,
    }
  },
  actions: {
    setStep(step: BasketStep) {
      this.step = step
    },
  },
})
